import React from 'react';
import PropTypes from 'prop-types';
import AccountNotificationsForm from './Form';

const AccountNotificationsView = ({ data, refetchData }) => {
  return (
    <div>
      <AccountNotificationsForm initialData={data} refetchData={refetchData} />
    </div>
  );
};

AccountNotificationsView.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
  refetchData: PropTypes.func.isRequired,
};

AccountNotificationsView.defaultProps = {
  data: {},
};

export default AccountNotificationsView;
